// permissions.js
export const ROLES = Object.freeze({
  guest: 'guest', //ทั่วไป
  admin: 'admin', //เจ้าหน้าที่ส่วนกลาง
  staff: 'staff', //ผู้ดูแลศูนย์พักพิง
  team_leader: 'team_leader', //เจ้าหน้าปฏิบัติการ
  team_member: 'team_member',
});

export const normalizeRole = (raw) => {
  if (raw == null) return ROLES.guest;
  const key = String(raw).trim().toLowerCase();

  const MAP = {
    guest: ROLES.guest,
    admin: ROLES.admin,
    staff: ROLES.staff,
    team_leader: ROLES.team_leader,
    team_member: ROLES.team_member,
  };
  return MAP[key] ?? ROLES.guest;
};

export const PERM = {
  VIEW_DASHBOARD: 1 << 0,
  VIEW_DISASTER: 1 << 1,
  VIEW_SHELTER: 1 << 2,
  VIEW_MEDICAL: 1 << 3,
  VIEW_EMERGENCY_REQ: 1 << 4,
  VIEW_POPULATION: 1 << 5,
  VIEW_OFFICER: 1 << 6,
  VIEW_RESOURCES: 1 << 7,
  VIEW_PUBLIC_REL: 1 << 8,
  VIEW_OFFLINE: 1 << 9,
}

const ALL = Object.values(PERM).reduce((a, b) => a | b, 0);

export const ROLE_PERMISSIONS = {
  [ROLES.guest]: PERM.VIEW_DASHBOARD | PERM.VIEW_DISASTER | PERM.VIEW_PUBLIC_REL,
  [ROLES.admin]: ALL,
  [ROLES.staff]: PERM.VIEW_DASHBOARD | PERM.VIEW_DISASTER | PERM.VIEW_SHELTER | PERM.VIEW_PUBLIC_REL,
  [ROLES.team_leader]: PERM.VIEW_DASHBOARD | PERM.VIEW_DISASTER | PERM.VIEW_SHELTER | PERM.VIEW_MEDICAL | PERM.VIEW_EMERGENCY_REQ | PERM.VIEW_OFFICER | PERM.VIEW_POPULATION | PERM.VIEW_PUBLIC_REL | PERM.VIEW_OFFLINE,
  [ROLES.team_member]: PERM.VIEW_DASHBOARD | PERM.VIEW_DISASTER | PERM.VIEW_SHELTER | PERM.VIEW_MEDICAL | PERM.VIEW_EMERGENCY_REQ | PERM.VIEW_POPULATION | PERM.VIEW_PUBLIC_REL | PERM.VIEW_OFFLINE,
}
